export default __webpack_public_path__ + "static/live-alchemy-logo-edef53ab8188d12e8a873cdd4f80cc82.png";